import React from 'react'
import { Table } from 'react-bootstrap'
import { formatTimeString } from '../../utils/formatters'

const renderBooleanLabel = (value) => (value ? <i className='fa fa-check' /> : <i className='fa fa-minus' />)

export const SupportedDocumentsTable = ({ results }) => {
  return (
    <Table striped bordered hover responsive>
      <thead>
        <tr>
          <th>Name</th>
          <th>Class</th>
          <th>Issuer Code</th>
          <th>Issuer Name</th>
          <th>Bar Code</th>
          <th>Expiration Date</th>
          <th>Updated</th>
        </tr>
      </thead>
      <tbody>
        {results &&
          results.map((i) => (
            <tr key={i.id}>
              <td>{i.document_name}</td>
              <td>{i.document_class}</td>
              <td>{i.issuer_code}</td>
              <td>{i.issuer_name}</td>
              <td>{renderBooleanLabel(i.has_2d_bar_code)}</td>
              <td>{renderBooleanLabel(i.has_expiration_date)}</td>
              <td>{formatTimeString(i.updated, 'M/D/YYYY')}</td>
            </tr>
          ))}
      </tbody>
    </Table>
  )
}
